import styled from 'styled-components';

const List = styled.ul`
  padding-inline-start: 0;
  padding-inline-end: 0;
  margin-block-start: 0;
  margin-block-end: 0;
  overflow-wrap: break-word;
  list-style-type: none;
`;

export default List;
